module.exports = __webpack_public_path__ + "static/media/2 6 Ordkjedetest-Feil-hus-grei-norming.3a94f067.mp3";